var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15.75,
  height: 15.75,
  x: 0.625,
  y: 0.625,
  stroke: "#888",
  strokeWidth: 1.25,
  rx: 7.875
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 9.842,
  height: 8.947,
  x: 3.579,
  y: 4.026,
  fill: "#888",
  rx: 4.474
})));
export default SvgDot;